/**
 * Vision API module
 */
import { coreClient, apiRequest } from '../client.js';
import type { JsonValue } from '../types.js';

export const visionApi = {
  analyze: (imageData: string | Blob) => {
    const formData = new FormData();
    if (typeof imageData === 'string') {
      formData.append('imageUrl', imageData);
    } else {
      formData.append('image', imageData);
    }
    
    return apiRequest<Record<string, JsonValue>>(coreClient, {
      method: 'POST',
      url: '/vision/analyze',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
};

export default visionApi;
